import { SearchTerm } from "./SearchTerm";

const MapRelaySearch: SearchTerm[] = [
    {
        heading: "Name",
        accessor: "name",
        searchOnName: "name",
        translationKey: "name"
    },
];

export default MapRelaySearch;